import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import { isOnOnboardingView } from 'v3/helpers/RouteHelper';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import {
  startUsageHeartbeat,
  trackMenuItemChange,
} from '../helper/usageTracking';

const ONBOARDING_STEPS = ['account_details', 'enrichment'];
// Meu espaço (spec 143) é aberto a qualquer usuário logado, então é o destino
// padrão do login para todos.
const LANDING_PAGE = 'painel/meu-espaco';
const MCP_AUTHORIZE_RESUME_KEY = 'mcp_authorize_resume';
const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = async (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    // The login always lands on the default page, so remember the consent screen to come back to it
    if (to.name === 'mcp_authorize') {
      sessionStorage.setItem(MCP_AUTHORIZE_RESUME_KEY, to.fullPath);
    }
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'mcp_authorize') return next();

  const resumePath = sessionStorage.getItem(MCP_AUTHORIZE_RESUME_KEY);
  if (resumePath) {
    sessionStorage.removeItem(MCP_AUTHORIZE_RESUME_KEY);
    return next(resumePath);
  }

  const routeAccountId = Number(to.params?.accountId || accountId);
  const userAccount = accounts.find(a => a.id === routeAccountId);
  const isAdmin = userAccount?.role === 'administrator';
  const isActive = userAccount?.status === 'active';
  const needsOnboarding =
    ONBOARDING_STEPS.includes(userAccount?.onboarding_step) &&
    isAdmin &&
    isActive;

  if (to.name === 'no_accounts' || !to.name) {
    const target = needsOnboarding ? 'onboarding' : LANDING_PAGE;
    return next(frontendURL(`accounts/${routeAccountId}/${target}`));
  }

  if (needsOnboarding && !isOnOnboardingView(to)) {
    return next(frontendURL(`accounts/${routeAccountId}/onboarding`));
  }
  if (!needsOnboarding && isOnOnboardingView(to)) {
    return next(frontendURL(`accounts/${routeAccountId}/${LANDING_PAGE}`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async (to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    await userAuthentication;
    await validateAuthenticateRoutePermission(to, next, store);
  });

  router.afterEach(trackMenuItemChange);
  startUsageHeartbeat();
};

export default router;
